module.exports = __webpack_public_path__ + "static/media/guiaDeEstudioFinalExamenTIC.80fdf785.pdf";